import Cookies from "js-cookie";

export const getCookie = async (key) => {
  if(!Cookies.get(key) || Cookies.get(key) === 'undefined') {
    return undefined;
  }

  return Promise.resolve(JSON.parse(Cookies.get(key) || null))
};

export const setCookie = async (key, state) => {
  await Cookies.set(key, JSON.stringify(state), {
    expires: 7,
    sameSite: 'Lax',
    domain: window.location.hostname
  });

  return Promise.resolve()
};
